import Logo from "@/components/7fcc/Logo";
import { scrollToId } from "@/lib/scroll";
import { APPLY } from "@/data/applyContent";

// Slim top bar: logo home, "Back To Home" link, booking CTA.
export default function ApplyNav() {
  return (
    <header
      className="sticky top-0 z-40 border-b border-line bg-ink-950/85 backdrop-blur-md"
      data-testid="apply-nav"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-3.5">
        <a href="/" aria-label="7 Figure Closing Club — home" data-testid="apply-nav-logo">
          <Logo className="w-24 md:w-28" />
        </a>
        <div className="flex items-center gap-3 md:gap-5">
          <a
            href="/"
            data-testid="apply-nav-back"
            className="text-xs font-semibold uppercase tracking-[0.18em] text-fg-muted transition-colors duration-300 hover:text-fg"
          >
            {APPLY.nav.backLabel}
          </a>
          <button
            type="button"
            data-testid="apply-nav-cta"
            onClick={() => scrollToId(APPLY.nav.ctaTarget)}
            className="inline-flex items-center justify-center rounded-full bg-brand px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-white shadow-glow-soft transition-all duration-300 ease-out hover:-translate-y-0.5 hover:bg-brand-light"
          >
            {APPLY.nav.ctaLabel}
          </button>
        </div>
      </div>
    </header>
  );
}
